<mat-form-field [class.mat-form-field-invalid]="hasError()" appearance="outline" class="autocomplete-container w-100 tight-input {{ getClass() }}" subscriptSizing="dynamic">
  <input
    type="search"
    matInput
    [placeholder]="placeholder"
    [(ngModel)]="inputValue"
    [ngModelOptions]="{ standalone: true }"
    [disabled]="disabled"
    (input)="onInputChanged($event)"
    (blur)="onBlur()"
    (search)="onCancel($event)"
    [matAutocomplete]="auto"/>
  @if (loading) {
    <div class="loading-autocomplete">
      <mat-spinner class="spinner" diameter="20"></mat-spinner>
    </div>
  }
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
    @for (option of filteredOptions | async; track option.value) {
      <mat-option [disabled]="setDisabled(option) || option.disabled" [value]="option.text" (click)="selectionConfig.clickOption?.(option?.value)">
        @if (selectionConfig.customOptionRenderer) {
          <ng-template *ngComponentOutlet="selectionConfig.customOptionRenderer; inputs: { option }" />
        } @else {
          {{ option.text }}
        }
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
